import React from "react";
import "./highroof-van.css";
import imagehighroof from "../../assets/images/Home/high-roof-van-service-chiller-dubai-sharjah-rent-freeze.webp";

const ChillerFreezeSectionHighRoof = () => {
  const whatsappNumber = "971544792905";

  return (
    <section className="py-5">
      <div className="container-fluid container-lg">
        <div className="row about-us-container mx-auto align-items-center">
          
          {/* Image Column */} 
          <div className="col-md-6 col-lg-5 col-xl-5" data-aos="fade-left" data-aos-delay="300">
            <img 
              className="img-fluid rounded h-100 w-100" 
              src={imagehighroof} 
              alt="High Roof Chiller and Freezer Vans for Safe Transport in Dubai" 
            />
          </div>

          {/* Text Column */}
          <div data-aos="fade-right" data-aos-delay="300" className="col-md-6 col-lg-7 col-xl-6 mt-4 mt-md-0 d-flex flex-column justify-content-center text-center text-md-start">
            <h2>High Roof Chiller & Freezer Vans for Safe and Efficient Transport in Dubai</h2>
            <p>
              High roof vans with a 1.5-ton capacity are built with spacious vertical rooms, 
              ideal for storing chilled and frozen products safely. Equipped with shelves, 
              they prevent goods from colliding, reducing damage during transport. 
              Perfect for businesses transporting perishable foods, dairy, frozen items, 
              and beverages, these vans ensure secure, organized, and efficient delivery 
              across Dubai and UAE.
            </p>

            {/* WhatsApp Button */}
            <div className="d-flex justify-content-center justify-content-md-start gap-3 mt-3">
              <a 
                href={`https://wa.me/${whatsappNumber}`} 
                className="btn--primary"
                aria-label="Chat with Chiller Fleet  via WhatsApp"
              >
                Whatsapp Now
              </a>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default ChillerFreezeSectionHighRoof;